import React from "react";
import QRCode from "react-qr-code";

/**
 * Premium government-style ID card preview. Always renders a card; if no member
 * provided, shows a tasteful sample.
 */
export default function DigitalIDCard({ member, size = "md" }) {
  const m = member || {
    full_name: "Ananya R. Menon",
    designation: "Technical Assistant",
    district: "Ernakulam",
    local_body_name: "Vyttila",
    local_body_type: "Grama Panchayat",
    membership_id: "KELTA-2026-00001",
    expiry_date: "2027-01-15T00:00:00Z",
    photo_url: "https://i.pravatar.cc/200?img=47",
  };
  const verifyUrl = `${window.location.origin}/verify/${m.membership_id || "PREVIEW"}`;
  const dims = size === "sm" ? "w-[320px] h-[200px]" : "w-full max-w-[420px] aspect-[1.6/1]";
  const localBodyFull = (() => {
    const name = (m.local_body_name || "").trim();
    const type = (m.local_body_type || "").trim();
    if (!type) return name;
    if (!name) return type;
    if (name.toLowerCase().includes(type.toLowerCase())) return name;
    return `${name} ${type}`;
  })();

  return (
    <div className={`relative ${dims} rounded-2xl overflow-hidden shadow-2xl ring-1 ring-black/10 id-glow`}>
      {/* deep blue luxury holo */}
      <div className="absolute inset-0 id-holo" />
      {/* glossy shine sweep */}
      <div className="absolute inset-0 id-shine opacity-60 mix-blend-overlay" />
      <div className="absolute inset-0 bg-gradient-to-br from-white/0 via-white/0 to-black/40" />

      {/* watermark grid */}
      <svg className="absolute inset-0 w-full h-full opacity-[0.07]" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="g" width="20" height="20" patternUnits="userSpaceOnUse">
            <path d="M 20 0 L 0 0 0 20" fill="none" stroke="white" strokeWidth="0.6" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#g)" />
      </svg>

      {/* Top stripe */}
      <div className="absolute top-0 left-0 right-0 h-2 gov-stripe" />

      <div className="relative h-full p-5 text-white flex flex-col">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <div className="text-[8px] uppercase tracking-[0.22em] text-white/70 leading-tight">
              Kerala Local Body<br />Technical Assistants Association
            </div>
            <div className="font-black text-lg leading-tight mt-1">KELTA Member</div>
          </div>
          <div className="text-right flex-shrink-0">
            <div className="text-[10px] uppercase tracking-[0.18em] text-white/70">ID No.</div>
            <div className="font-mono font-bold text-sm">{m.membership_id}</div>
          </div>
        </div>

        <div className="mt-auto flex items-end gap-3">
          <div className="w-16 h-20 rounded-md overflow-hidden ring-2 ring-white/60 bg-white/10 flex-shrink-0">
            {m.photo_url ? (
              <img src={m.photo_url} alt={m.full_name} className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-2xl font-bold text-white/80">
                {(m.full_name || "?")[0]}
              </div>
            )}
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-bold text-base truncate">{m.full_name}</div>
            <div className="text-xs text-white/80 truncate">{m.designation}</div>
            <div className="text-[11px] text-white/70 truncate">{localBodyFull}</div>
            <div className="text-[11px] text-white/70">{m.district} District</div>
          </div>
          <div className="flex flex-col items-center gap-1">
            <div className="bg-white p-1 rounded">
              <QRCode value={verifyUrl} size={56} bgColor="#FFFFFF" fgColor="#0A1930" />
            </div>
            <div className="text-[8px] text-white/70 uppercase tracking-wider">Scan to verify</div>
          </div>
        </div>

        <div className="absolute bottom-2 left-5 right-5 flex items-center justify-between text-[9px] text-white/60 uppercase tracking-wider">
          <span>Valid till {(m.expiry_date || "2027-01-15").slice(0, 10)}</span>
          <span>kelta.co.in</span>
        </div>
      </div>
    </div>
  );
}
